import getChangelogs from '../all-changelogs';

function ChangelogsPageMain() {
    const changelogs = getChangelogs();
    
    return (
        <main className="max-w-4xl mx-auto px-4 py-12 mt-[60px]">
            <div className="mb-16">
                <h2 className="text-4xl font-bold mb-4 tracking-tight">Software Updates</h2>
                <p className="text-slate-400 max-w-2xl">Track the evolution of the LiveTelemetry client. Our engineering team continuously optimizes data ingestion, visualization, and performance for professional sim racing environments.</p>
            </div>

            <div className="space-y-12">
                {changelogs.map((item) => (
                    item.release === "Current Release" ?
                        <div key={item.version} className="relative timeline-line">
                            <div className="absolute left-0 top-0 w-10 h-10 rounded-full bg-primary/20 border-2 border-primary flex items-center justify-center z-10">
                                <div className="w-2.5 h-2.5 rounded-full bg-primary animate-pulse"></div>
                            </div>
                            <div className="ml-16">
                                <div className="glass-panel rounded-xl p-6 border-l-4 border-l-primary shadow-2xl shadow-primary/5">
                                    <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
                                        <div className="flex items-center gap-4">
                                            <h3 className="text-2xl font-mono font-bold text-white">{item.version}</h3>
                                            <span className="bg-primary/10 text-primary px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest border border-primary/20">{item.release}</span>
                                        </div>
                                        <span className="text-slate-500 font-mono text-sm">Released: {item.date} • {item.dimensions}</span>
                                    </div>
                                    <div className="grid grid-cols-1 gap-8">
                                        {item.added.length !== 0 &&
                                            <section>
                                                <div className="flex items-center gap-2 mb-4 text-success">
                                                    <span className="material-symbols-outlined">add_circle</span>
                                                    <h4 className="font-bold uppercase text-xs tracking-widest">Added</h4>
                                                </div>
                                                <ul className="space-y-3 font-mono text-sm text-slate-300">
                                                    {item.added.map((added) => (
                                                        <li className="flex items-start gap-3 bg-white/5 p-3 rounded border border-white/5">
                                                            <span className="text-success mt-0.5">»</span>
                                                            <span>{added.text}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </section>
                                        }
                                        
                                        {item.improved.length !== 0 &&
                                            <section>
                                                <div className="flex items-center gap-2 mb-4 text-primary">
                                                    <span className="material-symbols-outlined">settings</span>
                                                    <h4 className="font-bold uppercase text-xs tracking-widest">Improved</h4>
                                                </div>
                                                <ul className="space-y-3 font-mono text-sm text-slate-300">
                                                    {item.improved.map((improved) => (
                                                        <li className="flex items-start gap-3 bg-white/5 p-3 rounded border border-white/5">
                                                            <span className="text-primary mt-0.5">»</span>
                                                            <span>{improved.text}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </section>
                                        }

                                        {item.fixed.length !== 0 &&
                                            <section>
                                                <div className="flex items-center gap-2 mb-4 text-warning">
                                                    <span className="material-symbols-outlined">bug_report</span>
                                                    <h4 className="font-bold uppercase text-xs tracking-widest">Fixed</h4>
                                                </div>
                                                <ul className="space-y-3 font-mono text-sm text-slate-300">
                                                    {item.fixed.map((fixed) => (
                                                        <li className="flex items-start gap-3 bg-white/5 p-3 rounded border border-white/5">
                                                            <span className="text-warning mt-0.5">»</span>
                                                            <span>{fixed.text}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </section>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        :

                        <div key={item.version} className="relative timeline-line">
                            <div className="absolute left-0 top-0 w-10 h-10 rounded-full bg-slate-800 border-2 border-slate-700 flex items-center justify-center z-10">
                                <div className="w-2 h-2 rounded-full bg-slate-600"></div>
                            </div>
                            <div className="ml-16 opacity-70 hover:opacity-100 transition-opacity">
                                <div className="glass-panel rounded-xl p-6">
                                    <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
                                        <div className="flex items-center gap-4">
                                            <h3 className="text-xl font-mono font-bold text-white/80">{item.version}</h3>
                                            <span className="bg-slate-800 text-slate-400 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest border border-slate-700">{item.release}</span>
                                        </div>
                                        <span className="text-slate-500 font-mono text-xs">Released: {item.date} • {item.dimensions}</span>
                                    </div>
                                    <div className="space-y-6">
                                        {item.added.length !== 0 &&
                                            <section>
                                                <div className="flex items-center gap-2 mb-3 text-success/80">
                                                    <span className="material-symbols-outlined text-sm">add_circle</span>
                                                    <h4 className="font-bold uppercase text-[10px] tracking-widest">Added</h4>
                                                </div>
                                                <ul className="space-y-2 font-mono text-xs text-slate-400">
                                                    {item.added.map((added) => (
                                                         <li className="flex items-center gap-2">
                                                            <span className="text-success/50">•</span>
                                                            <span>{added.text}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </section>
                                        }

                                        {item.improved.length !== 0 &&
                                            <section>
                                                <div className="flex items-center gap-2 mb-3 text-primary/80">
                                                    <span className="material-symbols-outlined text-sm">settings</span>
                                                    <h4 className="font-bold uppercase text-[10px] tracking-widest">Improved</h4>
                                                </div>
                                                <ul className="space-y-2 font-mono text-xs text-slate-400">
                                                    {item.fixed.map((fixed) => (
                                                         <li className="flex items-center gap-2">
                                                            <span className="text-primary/50">•</span>
                                                            <span>{fixed.text}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </section>
                                        }

                                        {item.fixed.length !== 0 &&
                                            <section>
                                                <div className="flex items-center gap-2 mb-3 text-warning/80">
                                                    <span className="material-symbols-outlined text-sm">bug_report</span>
                                                    <h4 className="font-bold uppercase text-[10px] tracking-widest">Fixed</h4>
                                                </div>
                                                <ul className="space-y-2 font-mono text-xs text-slate-400">
                                                    {item.fixed.map((fixed) => (
                                                         <li className="flex items-center gap-2">
                                                            <span className="text-warning/50">•</span>
                                                            <span>{fixed.text}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </section>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                ))}
            </div>

            <div className="mt-20 p-8 rounded-xl bg-gradient-to-br from-primary/10 to-transparent border border-primary/20 flex flex-col md:flex-row items-center justify-between gap-8">
                <div className="max-w-md">
                    <h4 className="text-xl font-bold mb-2">Technical Difficulties?</h4>
                    <p className="text-slate-400 text-sm">Our engineering documentation covers every parameter of the client. For real-time assistance, join our racing engineer community on Discord.</p>
                </div>
                <div className="flex gap-4">
                    <button className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-lg font-bold text-sm transition-colors border border-white/10">
                        Read Docs
                    </button>
                    <button className="bg-[#5865F2] hover:bg-[#4752C4] text-white px-6 py-3 rounded-lg font-bold text-sm transition-colors">
                        Join Discord
                    </button>
                </div>
            </div>
        </main>
    );
}


export default ChangelogsPageMain;